import script from "./GridComenzi.vue?vue&type=script&lang=ts&setup=true"
export * from "./GridComenzi.vue?vue&type=script&lang=ts&setup=true"

import "./GridComenzi.vue?vue&type=style&index=0&id=36c9aca5&scoped=true&lang=css"
import "./GridComenzi.vue?vue&type=style&index=1&id=36c9aca5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36c9aca5"]])

export default __exports__